<div cdkDropList (cdkDropListDropped)="drop($event)">
  <h4 *ngIf="group.id !== 'root'">{{ group.title ?? getDefaultGroupTitle() }}</h4>
  <button mat-button type="button" color="primary" (click)="addField()" i18n>Add field</button>
  <div *ngFor="let field of group.fields; let i = index" cdkDrag>
    <mat-card appearance="outlined">
      <ng-container [ngSwitch]="field.type">
        <ng-container *ngSwitchCase="'group'">
          <eas-builder-group [group]="field"></eas-builder-group>
        </ng-container>
        <ng-container *ngSwitchCase="'array'">
          <eas-builder-group [group]="field"></eas-builder-group>
        </ng-container>
        <ng-container *ngSwitchCase="'field'">
          {{ field.name ?? field.options.label }} - {{ field.fieldType}}
        </ng-container>
      </ng-container>
      <button mat-button type="button" color="primary" (click)="editField(i)" i18n>Edit</button>
      <button mat-button type="button" color="warn" (click)="removeField(i)" i18n>Remove</button>
    </mat-card>
  </div>
</div>
